import styled from 'styled-components';

export const StContentContainer = styled.div`
    max-width: 950px;
    font-size: 14px;
    padding: 50px 0;
    line-height: 1.15;

    .P1 {
        margin-bottom: 10px;
    }
`;

export const StHeading = styled.h2`
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
`;
interface ListingProps {
    leftOffset?: boolean;
}
export const StListing = styled.ol<ListingProps>`
    margin-left: ${props => (props.leftOffset ? '15px' : 'initial')};
    counter-reset: list;
`;

export const StListItem = styled.li`
    list-style-type: initial;
`;
export const StAlphabetListItem = styled.li`
    list-style: none;
    display: flex;
    &:before {
        content: '(' counter(list, lower-alpha) ')';
        counter-increment: list;
    }
`;

export const StListText = styled.span`
    /* position: relative;
    left: 5px; */
    margin-left: 10px;
    float: right;
`;

export const StSubHeading = styled.span`
    font-size: 14px;
    font-weight: bold;
`;
